// 中文语言包
export const zh = {
  language: "zh",
  // 导航
  nav: {
    home: "首页",
    chat: "AI对话练习",
    textAnalysis: "文本分析",
    imageAnalysis: "图片分析",
    history: "学习历史"
  },
  
  // 首页
  home: {
    title: "Linguamate Pro",
    subtitle: "智能语言学习助手",
    description: "通过AI技术提升您的语言学习体验",
    hero: {
      title: "让 AI 结合语言学原理",
      subtitle: "打造个性化语言学习体验",
      description: "Linguamate Pro 是一个多模态语言学习伴侣，利用人工智能帮助学习者在真实语境中掌握语言",
      startTextAnalysis: "开始文本分析",
      uploadImage: "上传图片分析"
    },
    features: {
      chat: "AI对话练习",
      textAnalysis: "文本分析",
      imageAnalysis: "图片分析",
      history: "学习历史",
      textAnalysisDesc: "上传文本内容进行AI驱动的语言学分析，包括词汇、语法和语义分析",
      imageAnalysisDesc: "上传教材截图或图片进行OCR识别和语言学分析",
      chatDesc: "通过AI在真实场景中进行实时对话练习，提升语言技能"
    },
    coreFeatures: "核心功能",
    whyChoose: "为什么选择 Linguamate Pro？",
    demo: "演示场景",
    cta: {
      title: "开始你的语言学习之旅",
      description: "体验 AI 驱动的个性化语言学习",
      startNow: "立即开始"
    },
    getStarted: "开始使用",
    highlights: {
      linguisticsDriven: "语言学驱动",
      linguisticsDrivenDesc: "基于形态学、句法学、语义学、语用学等语言学理论",
      personalizedLearning: "个性化学习",
      personalizedLearningDesc: "根据学习者水平生成适合的学习材料和练习",
      immersiveExperience: "沉浸式体验",
      immersiveExperienceDesc: "在真实语境中学习，提高语言实际运用能力"
    },
    demoScenarios: {
      title: "演示场景",
      uploadTextbook: "上传教材截图",
      uploadTextbookDesc: "AI 识别并输出词汇表和语法解析",
      chooseLearningMode: "选择学习模式",
      chooseLearningModeDesc: "AI 用简化语言生成摘要和练习",
      chatPractice: "对话练习",
      chatPracticeDesc: "模拟真实情境，AI 作为对话伙伴互动"
    }
  },
  
  // AI对话练习
  chat: {
    title: "AI对话练习",
    subtitle: "与AI进行自然对话，提升语言能力",
    placeholder: "输入您的消息...",
    send: "发送",
    level: "学习等级",
    context: "对话场景",
    contexts: {
      casual: "日常对话",
      business: "商务交流",
      academic: "学术讨论",
      travel: "旅行交流"
    },
    levels: {
      beginner: "初级",
      intermediate: "中级",
      advanced: "高级"
    },
    learningSettings: "学习设置",
    learningContext: "学习上下文（可选）",
    contextPlaceholder: "例如：餐厅点餐、商务会议等",
    conversationStarters: "对话开始语",
    clearChat: "清空对话",
    noMessages: "还没有消息，开始对话吧！",
    sampleScenarios: "示例场景"
  },
  
  // 文本分析
  textAnalysis: {
    title: "文本分析",
    subtitle: "深度分析文本，生成个性化练习",
    step1: "步骤1: 输入文本",
    step2: "步骤2: 语言学分析",
    step3: "步骤3: 练习题",
    inputPlaceholder: "请输入要分析的英文文本...",
    analyze: "开始分析",
    generateExercises: "生成练习题",
    restart: "重新开始",
    level: "学习等级",
    analysisComplete: "分析完成",
    exercisesComplete: "练习生成完成",
    submitAnswer: "提交答案",
    yourAnswer: "你的答案",
    correctAnswer: "正确答案",
    explanation: "解析",
    correct: "回答正确！",
    incorrect: "回答错误",
    originalText: "原始文本",
    originalTextTitle: "您输入的文本内容",
    originalTextDescription: "以下是您刚才输入的文本，用于生成语言学分析和练习题"
  },
  
  // 图片分析
  imageAnalysis: {
    title: "图片分析",
    subtitle: "上传图片进行OCR和语言分析",
    upload: "上传图片",
    analyze: "分析图片",
    result: "分析结果",
    step1: "步骤1: 上传图片",
    step2: "步骤2: 图片识别",
    step3: "步骤3: 语言分析",
    step4: "步骤4: 练习题",
    uploadPlaceholder: "点击或拖拽图片到此处",
    supportedFormats: "支持 JPG、PNG、GIF 格式",
    analysisComplete: "分析完成",
    ocrComplete: "OCR识别完成",
    noImage: "请先上传图片",
    processing: "正在处理...",
    restart: "重新开始",
    extractedText: "识别的文本内容",
    analysisResult: "语言学分析结果",
    generateExercises: "生成练习题",
    personalizedExercises: "个性化练习题",
    exercisesComplete: "练习生成完成",
    startAnalysis: "开始分析"
  },
  
  // 学习历史
  history: {
    title: "学习历史",
    subtitle: "查看您的学习记录和进度",
    noHistory: "暂无学习记录",
    date: "日期",
    type: "类型",
    content: "内容",
    score: "得分",
    textAnalysis: "文本分析",
    imageAnalysis: "图片分析",
    chatPractice: "对话练习",
    loading: "加载中...",
    error: "加载失败，请重试"
  },
  
  // 通用
  common: {
    loading: "加载中...",
    error: "出错了",
    retry: "重试",
    success: "成功",
    cancel: "取消",
    confirm: "确认",
    save: "保存",
    delete: "删除",
    edit: "编辑",
    close: "关闭"
  }
};
